export const Dark = ({ translate }: { translate: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    style={{ translate }}
  >
    <path d="M481.15-127q-147.08 0-250.04-102.96Q128.16-332.92 128.16-480q0-141.18 95.9-242.09Q319.97-823 458.84-831.08q3.62 0 9.43.12 5.8.12 16.8 1.35-21.61 29.61-34.26 69.15-12.66 39.54-12.66 77.46 0 101.33 73.34 173.67Q584.82-437 687.15-437q39.43 0 73.72-11.15 34.28-11.16 68.51-37.77 1.23 3 1.85 13.31.61 10.3.61 14.92-7.69 138.88-108.59 234.78Q622.34-127 481.15-127Zm0-86q73 0 136.5-37.5t98.5-101.5q-6 0-14 .5t-14 .5q-139.62 0-237.81-97.02T352.15-683q0-11 .5-19t1.5-13q-65 35-102.5 98t-37.5 137q0 110.61 78.2 188.81Q370.54-213 481.15-213Zm-16-251Z" />
  </svg>
);
